import React from "react";
import { CheckCircle2 } from "lucide-react";

const colorMap = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  yellow: "bg-amber-50 text-amber-700 border-amber-200",
  red: "bg-rose-50 text-rose-700 border-rose-200",
  blue: "bg-blue-50 text-blue-700 border-blue-200",
  violet: "bg-violet-50 text-violet-700 border-violet-200",
  slate: "bg-slate-50 text-slate-700 border-slate-200",
};

export default function Pill({ color="slate", icon: Icon=CheckCircle2, children, w="w-28" }) {
  return (
    <span className={`inline-flex h-6 ${w} items-center justify-center gap-1.5 rounded-full border px-2 text-[11px] font-semibold ${colorMap[color]}`}>
      <Icon size={14} /> {children}
    </span>
  );
}
